
<script>
export default {
    name: "CommonMixin",
    computed:{
        is_student() {
            return this.$store.state.user.roles.is_student
        },

    },
    methods:{
        goToProfile(query){

            if(!this.hasOnlyStudentRole()){
                // Открыть в новой вкладке
                const routeData = this.$router.resolve({
                    name: 'user-info',
                    query: query});
                window.open(routeData.href);
            }

        },

        hasOnlyStudentRole(){
            let roles = this.$store.state.user.roles
            let keys = Object.keys(this.$store.state.user.roles)
            let actual_roles = []
            keys.forEach((key)=>{
                if(roles[key]){
                    actual_roles.push(key)
                }
            })

            if (actual_roles.length === 1 && actual_roles.includes('IS_STUDENT'.toLowerCase())){
                return true
            }else{
                return false
            }
        }
    }
};
</script>

<style scoped>

</style>
